import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.favorites');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-favorites',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.favorites/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageFavoritesComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }
    public songs: any[] = [];
    public loading = true;
    public removingId: string = '';

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();
        let { code, data } = await wiz.call("load");
        if (code === 200) {
            this.songs = data.songs || [];
        }
        this.loading = false;
        await this.service.render();
    }

    public async removeFav(song: any) {
        if (this.removingId) return;
        let res = await this.service.modal.show({
            title: '즐겨찾기 해제',
            message: `"${song.title_ko}"를 즐겨찾기에서 제거하시겠습니까?`,
            action: '제거',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!res) return;
        this.removingId = song.id;
        await this.service.render();
        try {
            await wiz.call("remove", { song_id: song.id });
            await this.load();
        } finally {
            this.removingId = '';
            await this.service.render();
        }
    }

    public goSong(id: string) { this.service.href('/song/' + id); }
}

export default PageFavoritesComponent;